class SuppressedEmailAddresses {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/suppressed-email-addresses`;

  }

  async suppressEmailAddresses(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, { data });

  }

  async getSuppressedEmailAddressesByQueryOptions(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

}

export default SuppressedEmailAddresses;